export const initialState = {
  user: { name: null, email: null, avatar: null },
  message: '',
  token: null,
  isLoggedIn: false,
  isRefreshing: true,
  error: null,
};
